module.exports = __webpack_public_path__ + "static/media/support_help_icon.8c7d1f06.svg";